import { render } from "./main-skills-modal.vue?vue&type=template&id=3d42b8f7&ts=true"
import script from "./main-skills-modal.vue?vue&type=script&lang=ts"
export * from "./main-skills-modal.vue?vue&type=script&lang=ts"

import "./main-skills-modal.vue?vue&type=style&index=0&id=3d42b8f7&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__